import Vue from 'vue'
import appService from '../../server/app.service'
import _ from 'lodash'
import router from '../../router'

const state = {
    scriptTypes: [],
    scriptType: [],
    languages: [],
    languageSelected: 'ita',
    translations: [],
    id: 0
}

const getters = {
    scriptTypes: state => state.scriptTypes,
    scriptType: state => state.scriptType,
    languages: state => state.languages,
    languageSelected: state => state.languageSelected,
    translations: state => state.translations,
}

const actions = {

    loadScriptTypes (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            context.commit('loadScriptTypes', { scriptTypes: data })
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', data)
        })
    },

    loadScriptType (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            context.commit('loadScriptType', { scriptTypes: data })
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', data)

        })
    },

    createScriptType (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            context.commit('createScriptType', { scriptTypes: data })
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', data)

        })
    },

    async saveScriptType({ commit, dispatch }, credentials) {
        try {
            const data = await appService.connectToServer(credentials);
            if (data.success) {
                commit('saveScriptType', {
                    ScriptType: data.ScriptType,
                });
                dispatch('addMessage', data, { root: true });
                return data.ScriptType;
            }
            dispatch('addMessage', data, { root: true });
        } catch (err) {
            dispatch('addMessage', err.toString(), { root: true });
        }
    },

    deleteScriptType (context, credentials) {
        appService.connectToServer(credentials).then(data => {

            if( data.success ) {
                context.commit('deleteScriptType', { success: data.success, id: data.id  })
                this.dispatch('addMessage', data)
            } else {
                this.dispatch('addMessage', data)
            }

        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', data)

        })
    },

    languageSelect(context, slug) {
        context.commit('languageSelect', slug)
    },

    resetScriptType (context) {
        state.scriptType = [],
        state.languageSelected = 'ita',
        state.translations = []
    },

}

const mutations = {

    loadScriptTypes (state, data) {
        state.scriptTypes = data.scriptTypes.result
    },
    loadScriptType (state, data) {
        state.scriptType = data.scriptTypes.result
        state.scriptType.flagged = (state.scriptType.flagged == '1') ? 1 : 0;
        state.languages = data.scriptTypes.data.languages
        state.translations = data.scriptTypes.data.translations
    },
    createScriptType (state, data) {
        state.languages = data.scriptTypes.data.languages
        state.translations = data.scriptTypes.data.translations
    },
    saveScriptType(state, { ScriptType }) {
        state.scriptType.requestLogCreate = ScriptType.requestLogCreate;
        state.scriptType.requestLogUpade = ScriptType.requestLogUpade;
    },
    deleteScriptType (state, data) {
        let index = _.findIndex(state.scriptTypes, function(o) { return o.id == data.id; });
        state.scriptTypes.splice(index, 1)
    },
    languageSelect (state, slug) {
        state.languageSelected = slug.slug
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
